export const GET_INVITES_REQUEST = 'GET_INVITES_REQUEST'
export const GET_INVITES_SUCCESS = 'GET_INVITES_SUCCESS'
export const GET_INVITES_FAIL = 'GET_INVITES_FAIL'
export const GET_INVITES_RESET = 'GET_INVITES_RESET'
